import React, {useContext} from 'react';
import {Button, TextField} from '@material-ui/core';
import {useSelector} from 'react-redux';
import {ThemeContext} from '../../../themes/ThemeProvider';
import AddValueTable from './AddValueTable';
import {backButtonText} from '../../../util/Content';
import {ArrowBack} from '@material-ui/icons';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';

function AddLookupMaintenance({setValue, rowData, LookupMaintenanceAccess}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {successMsg, errorMsg, isLoading} = useSelector(
    ({addLookupMaintenance}) => addLookupMaintenance,
  );
  return (
    <>
      <div className={`mb-0`}>
        <div className="button-table-spacing-mb justify-content-start  new-standard-textfields">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn mx-1 ${classes.buttonRoot}`}
            onClick={() => {
              setValue(0);
            }}
          >
            <ArrowBack className="mr-2" />
            {backButtonText}
          </Button>
        </div>
        <div className="form-row align-items-center global-field-textfields new-standard-textfields">
          <div className="col-sm-6 col-md-4 col-lg-4 form-group">
            <TextField
              className={`${classes.labelName}`}
              placeholder="Enter Lookup Table Code"
              margin="dense"
              variant="outlined"
              label="Lookup Table Code"
              value={rowData?.typeCode || ''}
              disabled
              // InputLabelProps={{
              //   shrink: true,
              // }}
              fullWidth
            />
          </div>

          <div className="col-sm-6 col-md-4 col-lg-4 form-group">
            <TextField
              className={`${classes.labelName}`}
              placeholder="Enter Description"
              margin="dense"
              variant="outlined"
              label="Description"
              value={rowData?.description}
              disabled
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
            />
          </div>
        </div>
        <div className={`border-rounded`}>
          <AddValueTable rowData={rowData} LookupMaintenanceAccess={LookupMaintenanceAccess} />
        </div>
      </div>
      {isLoading && <PageLoader />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
    </>
  );
}

export default AddLookupMaintenance;
